import { colors } from 'style/colors';
import Icon from 'components/UI/Icons/Icon';
import styles from './styles.module.scss';

interface ICloseButtonProps {
  onClose: () => void;
}

export const CloseButton = ({ onClose }: ICloseButtonProps) => (
  <button
    type="button"
    className={styles.closeButton}
    onClick={onClose}
    aria-label="Close"
  >
    <span className={styles.iconWrapper}>
      <Icon
        iconType="cross"
        color={colors.shared.black}
        width={16}
        height={16}
      />
    </span>
  </button>
);
